import React from 'react'
import classes from './MoreInSeries.module.scss'
import VideoCarouselItem from './VideoCarouselItem/index'
import { getFileName } from '../../../../../helpers/FileCaching';
const posterImages = require.context('../../../../../images/components/Introduction/video_posters', true, /.*\.(gif|png|jpe?g|svg)$/i);
const contentImages = require.context('../../../../../images/components/Introduction', true, /.*\.(gif|png|jpe?g|svg)$/i);

function MoreInSeries({content, onItemSelection}){

   

	return (
		<section className={`${classes.MoreInSeries}`}>
           <p className={`${classes.MoreInSeries__title} subtitle_white_global`} dangerouslySetInnerHTML={{__html:content.title}}></p>
           <div>
                {content.episodes.map((element, index) => {
                    return (
                        <section className={`${classes.MoreInSeries__video_container}`} key={index}>
                            <VideoCarouselItem 
                                onPlayPress={() => {onItemSelection(index)}}
                                content={element}
                            />
                        </section>
                    )
                })}
           </div>
        </section>
	)
}

export default MoreInSeries